import React, { useMemo } from 'react';
import { string } from 'prop-types';
import styles from './styles/styles.module.scss';
import Expandable from '../../../shared/Expandable';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: {
    SUPPORT_EMAIL,
    GIFT_FLOW: {
      FAQ: {
        HOW_DO_I_REDEEM,
        HOW_DO_I_REDEEM_ANSWER,
        CAN_I_GIVE_A_SUBSCRIPTION,
        CAN_I_GIVE_A_SUBSCRIPTION_ANSWER,
        WILL_I_KNOW,
        WILL_I_KNOW_ANSWER,
        WAS_NOT_RECIEVED,
        WAS_NOT_RECIEVED_ANSWER,
        IS_THERE_AN_EXPIRATION,
        IS_THERE_AN_EXPIRATION_ANSWER,
        CAN_I_BUY_A_PHYSICAL_GIFT_CARD,
        CAN_I_BUY_A_PHYSICAL_GIFT_CARD_ANSWER,
        FREQUENTLY_ASKED_QUESTIONS
      },
      NEED_HELP_ASK_SUPPORT,
      HELP_CENTER
    }
  }
} = StringConstantsMixin;

const FrequentlyAskedQuestions = ({ languageRegionCode }) => {
  const needHelpText = useMemo(() => {
    const HELP = 'HELP';
    const MAIL_TO = 'MAIL_TO';
    const shortRegionCode = languageRegionCode.split('-')[0];

    return NEED_HELP_ASK_SUPPORT(MAIL_TO, HELP)
      .split(/(\bMAIL_TO|HELP+\b)/gi)
      .map(str => {
        if (str === MAIL_TO) {
          return (
            <>
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
              <br />
            </>
          );
        } else if (str === HELP) {
          return <a href={`https://support.alltrails.com/hc/${shortRegionCode}`}>{HELP_CENTER}</a>;
        }

        return <span>{str}</span>;
      });
  }, []);

  return (
    <section className={styles.container}>
      <h3 className={styles.header}>{FREQUENTLY_ASKED_QUESTIONS}</h3>
      <Expandable title={HOW_DO_I_REDEEM} classes={styles.expandable}>
        <div className={styles.dropdownText}>{HOW_DO_I_REDEEM_ANSWER}</div>
      </Expandable>
      <Expandable title={CAN_I_GIVE_A_SUBSCRIPTION} classes={styles.expandable}>
        <div className={styles.dropdownText}>
          <div dangerouslySetInnerHTML={CAN_I_GIVE_A_SUBSCRIPTION_ANSWER} />
        </div>
      </Expandable>
      <Expandable title={WILL_I_KNOW} classes={styles.expandable}>
        <div className={styles.dropdownText}>{WILL_I_KNOW_ANSWER}</div>
      </Expandable>
      <Expandable title={WAS_NOT_RECIEVED} classes={styles.expandable}>
        <div className={styles.dropdownText}>
          <div dangerouslySetInnerHTML={WAS_NOT_RECIEVED_ANSWER} />
        </div>
      </Expandable>
      <Expandable title={IS_THERE_AN_EXPIRATION} classes={styles.expandable}>
        <div className={styles.dropdownText}>{IS_THERE_AN_EXPIRATION_ANSWER}</div>
      </Expandable>
      <Expandable title={CAN_I_BUY_A_PHYSICAL_GIFT_CARD} classes={`${styles.expandable} ${styles.noBottomBorder}`}>
        <div className={styles.dropdownText}>{CAN_I_BUY_A_PHYSICAL_GIFT_CARD_ANSWER}</div>
      </Expandable>
      <div className={styles.needHelp}>{needHelpText}</div>
    </section>
  );
};

FrequentlyAskedQuestions.propTypes = {
  languageRegionCode: string
};

FrequentlyAskedQuestions.defaultProps = {
  languageRegionCode: 'en-US'
};

export default FrequentlyAskedQuestions;
